export default __webpack_public_path__ + "static/media/disc-bottom-fork-guards.990d7069.jpg";